var map = {
	"./Form.vue": "./Bread/Resources/ui/Pages/Form.vue",
	"./Index.vue": "./Bread/Resources/ui/Pages/Index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./Bread/Resources/ui/Pages sync recursive ^\\.\\/.*\\.vue$";